const INITIAL_STATE = {
  data: {},
  errors: {},

}
const addInitialCleaning = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_INITIAL_CLEANING_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_INITIAL_CLEANING_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default addInitialCleaning;